import React from "react";
import Button from "../Button";
import Gallery from "./Gallery";
import Table from "./Table";
import { Link } from "gatsby";
import { slug } from "../../utils";
import Slider from "react-slick";
import { testimonialSliderThree } from "../../sliderProps";
import VideoSection from "./VideoSection";
import FaqList from "../FAQ/FaqList";

export const parseURL = (ref) => {
  if (ref) {
    const split = ref.split("-");

    if (split.length === 4) {
      return `https://cdn.sanity.io/images/eo9g5l50/production/${split[1]}-${split[2]}.${split[3]}`;
    }
    return "";
  } else {
    return "";
  }
};

export const portableText = {
  marks: {
    color: ({ value, children }) => (
      <span style={{ color: value.hex }}>{children}</span>
    ),
    link: ({ value, children }) => {
      const target = (value?.href || "").startsWith("http")
        ? "_blank"
        : undefined;
      const isExternal = (value?.href || "").startsWith("http");

      if (!isExternal) {
        return (
          <Link
            to={slug(value?.href)}
            className="underline transition-colors duration-150 ease-linear underline-offset-8 hover:text-primary"
          >
            {children}
          </Link>
        );
      } else {
        return (
          <a
            href={value?.href}
            target={target}
            rel={target === "_blank" && "noindex nofollow"}
            className="underline transition-colors duration-150 ease-linear underline-offset-8 hover:text-primary"
          >
            {children}
          </a>
        );
      }
    },
  },
  block: {
    h1: ({ children }) => (
      <h1 className="text-4xl md:text-5xl mb-5 leading-[1.3] md:leading-[1.3]">
        {children}
      </h1>
    ),
    h2: ({ children }) => (
      <h2 className="text-3xl md:text-4xl mb-[20px] leading-[1.2] md:leading-[1.3]">
        {children}
      </h2>
    ),
    h3: ({ children }) => (
      <h3 className="text-2xl md:text-3xl mb-[10px] leading-[1.2] md:leading-[1.3]">
        {children}
      </h3>
    ),
  },
  list: {
    bullet: ({ children }) => (
      <ul className="choose-item-list wow fadeInDown pt-15 pb-15">
        {children}
      </ul>
    ),
  },
  listItem: {
    bullet: ({ children }) => (
      <li className="single-choose-item small-size mb-[8px]">
        <span>{children}</span>
      </li>
    ),
  },
  types: {
    gallery: ({ value }) => {
      console.log(value);
      if (value.enable) {
        return <Gallery data={value.images} />;
      }
    },
    table: ({ value }) => {
      return <Table value={value} />;
    },
    figure: ({ value }) => {
      return (
        <div className="img-container">
          <img src={parseURL(value?.asset?._ref)} alt={value?.alt} />
        </div>
      );
    },
    banner: ({ value }) => {
      return (
        <div className="banner">
          <h1>{value.heading}</h1>
          {value?.subheading && <h2>{value.subheading}</h2>}
        </div>
      );
    },
    videoSec: ({ value }) => {
      return (
        <div className="">
          <h2 className="!mb-[40px] text-3xl md:text-4xl">{value.heading}</h2>
          {value?.videos.length > 0 && <VideoSection videos={value.videos} />}
        </div>
      );
    },
    testimonials: ({ value }) => {
      return (
        <div>
          <Slider
            {...testimonialSliderThree}
            className="testimonial-slider-three"
          >
            {value.testimonialsList.map((testimonial, key) => {
              return (
                <div
                  className={`testimonial-item text-center wow fadeInDown`}
                  key={key}
                >
                  <div className="testimonial-content">
                    <h3>{testimonial?.name}</h3>
                    <p>{testimonial?.feedback}</p>
                    <div className="quote">
                      <i className="fas fa-quote-right" />
                    </div>
                    <div className="author-title">
                      <h4>{testimonial?.name}</h4>
                      <p className="position">{testimonial.designation}</p>
                    </div>
                  </div>
                </div>
              );
            })}
            {value.testimonialsList.map((testimonial, key) => {
              return (
                <div
                  className={`testimonial-item text-center wow fadeInDown`}
                  key={key}
                >
                  <div className="testimonial-content">
                    <h3>{testimonial?.name}</h3>
                    <p>{testimonial?.feedback}</p>
                    <div className="quote">
                      <i className="fas fa-quote-right" />
                    </div>
                    <div className="author-title">
                      <h4>{testimonial?.name}</h4>
                      <p className="position">{testimonial.designation}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </Slider>
        </div>
      );
    },
    faqSec: ({ value }) => <FaqList data={value} />,
    button: ({ value }) => {
      return (
        <div className="about-button mt-[20px] mb-[60px] wow fadeInDown">
          {value?.title && (
            <Button
              text={value.title}
              btnType={value?.btnType}
              link={value?.link}
              linkType={value?.linkType}
              pdf={value?.pdf}
              border="bordered-black"
            />
          )}
        </div>
      );
    },
  },
};
